import Image from "next/image";
import clsx from "clsx";

import checkboxIcon from "@/assets/icons/checkbox.svg";

type Props = {
  id: string;
  labelText: string;
  helperText?: string;
  checked: boolean;
  onClick: () => void;
  disabled?: boolean;
};

/* チェックボックス */
const CheckBoxComponent: React.FC<Props> = ({
  id,
  labelText,
  helperText,
  checked,
  onClick,
  disabled
}) => {
  return (
    <div
      className={clsx(
        "relative flex w-full items-center",
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      )}
    >
      <input
        type="checkbox"
        id={id}
        className="hidden"
        onClick={onClick}
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={clsx(
          "flex w-full cursor-pointer pl-32 before:absolute before:left-0 before:top-[0.1rem] before:block before:h-[2rem] before:w-[2rem] before:rounded-[0.2rem] before:bg-white after:absolute after:block ",
          checked ? "" : "before:border-2 before:border-gray-400",
          disabled ? "opacity-50" : "cursor-pointer"
        )}
      >
        <div className="absolute -left-[0.3rem] -top-[0.2rem] w-[2.6rem]">
          <div className={`${checked ? "" : "invisible"}`}>
            <Image src={checkboxIcon} alt="checkbox" />
          </div>
        </div>
        <div className="flex items-center gap-8">
          <p className="text-lg">{labelText}</p>
          {helperText && (
            <p className="text-md text-cCaptionGray">{helperText}</p>
          )}
        </div>
      </label>
    </div>
  );
};

export default CheckBoxComponent;
